import { render, staticRenderFns } from "./Transaction.vue?vue&type=template&id=e7d23ab6"
import script from "./Transaction.vue?vue&type=script&lang=js"
export * from "./Transaction.vue?vue&type=script&lang=js"
import style0 from "./Transaction.vue?vue&type=style&index=0&id=e7d23ab6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports